import { useMutation, useQueries, useQuery } from 'react-query';

import { httpClient } from 'app/api/http/http-client';
import { cardService } from 'app/utils/services/cardService';

export const accountService = {
  getAccountData: async () => {
    return await httpClient.post<any>('/api-web/v1/main/account_list');
  },
  setAccountName: async (data: { data: any }): Promise<any> => {
    const result = await httpClient.post<any>('/api-web/v1/main/account_list', data.data);

    return result;
  },
 
};

export const useGetAccount = () => {
  const {
    isFetching: isFetchingGetDataAccount,
    isLoading: isLoadingGetDataAccount,
    data: dataGetAccount,
    refetch: refetchGetDataAccount,
  } = useQuery('getAccountData', accountService.getAccountData , {
    staleTime : 5*60*1000
  });

  return { isFetchingGetDataAccount, isLoadingGetDataAccount, dataGetAccount, refetchGetDataAccount };
};

export const useSetAccountName = () => {
  const { refetchGetDataAccount } = useGetAccount();

  const {
    isLoading: isLoadingSetNameAccount,
    data: dataSetNameAccount,
    mutate: setAccountNameMutation,
  } = useMutation(['setAccountName'], (data: any) => accountService.setAccountName(data), {
    onSuccess: () => {
      refetchGetDataAccount();
    },
  });

  return { isLoadingSetNameAccount, dataSetNameAccount, setAccountNameMutation };
};


export const useGetAccountCard = () => {
  const queries = useQueries([
    {
      queryKey: 'accountData',
      queryFn: accountService.getAccountData,
    },
    {
      queryKey: 'cardData',
      queryFn: cardService.getCardData,
    },
  ]);

  const accounts = queries[0].data?.accounts;
  const cards = queries[1].data?.accounts;

  const accAndCards = accounts?.concat(cards);

  return { accAndCards };
};
